module.exports = __webpack_public_path__ + "img/Presentation.96ca6503.svg";